import React from 'react';
import { getI18NMessage } from './../../../i18n/I18N';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import UI_CONSTANTS from '../../app/constants/UIConstants';
import AppUtil, { getAppURL } from './../../../utils/AppUtil';
import { loadCaptchaScript, validateCaptcha } from '../actions/LoginActions';
import { FormControl, FormHelperText } from '@mui/material';

class ForgotPassword extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            tooManyRequest: false,
            locked: false,
            captchaError: undefined,
            reCaptchaClientId: undefined
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.sendForpassword = this.sendForpassword.bind(this);
        this.validateCaptchaAndSendForpassword = this.validateCaptchaAndSendForpassword.bind(this);
    }

    componentDidMount() {
        if(this.props.captcha) {
            loadCaptchaScript(this.props.captcha.sitekey, this.setState.bind(this));
        }
    }

    render() {
        const { appUrlHash, captcha } = this.props;
        const { captchaError, locked } = this.state;
        const enableSubmit = (this.state.username || '').trim();
        const invalidUsername = appUrlHash && appUrlHash.indexOf(UI_CONSTANTS.INVALID_URL_HASH) !== -1;
        let helperTextUsername = invalidUsername ? getI18NMessage('invalidusername') : '';

        if ( this.state.tooManyRequest ) {
            helperTextUsername = getI18NMessage('tooFrequentRequest');
        }

        return (
            <React.Fragment>
                <form id='sso-form-forgotpassword' onSubmit={ this.onSubmit } action='/rest/v1/users/forgotpassword'
                    method="post" >
                    <TextField size='small' label={ getI18NMessage('loginid') } 
                        name='username' className='lg-username' fullWidth autoFocus 
                        onChange={ this.onInputChange } onBlur={ this.onInputChange } 
                        error={ invalidUsername } helperText={ helperTextUsername }
                    />
                    {
                        captcha && 
                            <FormControl error={Boolean(captchaError)}>
                                <div className="captcha_wraper" id="captcha_wraper"></div>
                                { captchaError && <FormHelperText>{captchaError}</FormHelperText> }
                            </FormControl>
                    }
                    {
                        locked &&
                        <FormControl error={Boolean(locked)}>
                            {locked && <FormHelperText>{getI18NMessage('accountLocked')}</FormHelperText>}
                        </FormControl>
                    }
                    <div className='lg-form-buttons'>
                        <a href='#'>{ getI18NMessage('backtologin') }</a>
                        <Button variant="contained" disabled={ !enableSubmit }
                            onClick={ captcha ? this.validateCaptchaAndSendForpassword : this.sendForpassword }>{ getI18NMessage('submit') }</Button>
                    </div>
                </form>
                <div className='fp-info'>{ getI18NMessage('fpinfo') }</div>
                <a id='lg-invalid-reset-username' className='lg-form-hidden'
                    href={`${UI_CONSTANTS.FORGOT_PW_URL_HASH}${UI_CONSTANTS.INVALID_URL_HASH}`}/>
                <a id='lg-valid-reset-username' className='lg-form-hidden'
                    href={`?username=${encodeURIComponent(this.state.username)}${UI_CONSTANTS.FORGOT_PW_EMAIL_URL_HASH}`}/>
                <a id='lg-navigate-account-lockout' href={ `${UI_CONSTANTS.FORGOT_PW_URL_HASH}${UI_CONSTANTS.ACCOUNT_LOCKOUT}` } className='lg-form-hidden' />
            </React.Fragment>
        )
    }

    onInputChange(event) {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    validateCaptchaAndSendForpassword() {
        const { reCaptchaClientId } = this.state;

        validateCaptcha(reCaptchaClientId, "ForgotPassword", this.setState.bind(this), this.sendForpassword);
    }

    sendForpassword() {
        const URL = getAppURL('FORGOT_PASSWORD');

        AppUtil.ajax( URL, {
            username: this.state.username
        }, response => {
            if ( response.status === 401 ) {
                this.setState({
                    tooManyRequest: false
                })
                document.getElementById('lg-invalid-reset-username').click();
            } else if(response.status === 403){
                this.setState({
                    locked: true
                })
                document.getElementById('lg-navigate-account-lockout').click();
            }else if ( response.status === 429 ) {
                this.setState({
                    tooManyRequest: true
                })
            } else {
                document.getElementById('lg-valid-reset-username').click();
            }
        }, () => {
            this.setState({
                tooManyRequest: false
            })
            document.getElementById('lg-invalid-reset-username').click();
        }, true );
    }

    onSubmit(event) {
        event.preventDefault();

        if(this.props.captcha) {
            this.validateCaptchaAndSendForpassword();
        } else {
            this.sendForpassword();
        }

        return Boolean((this.state.username || '').trim());
    }
}

export default ForgotPassword;
